import { useEffect } from 'react';

import { useStatusServiceBridge } from '@web/components/StatusServiceBridgeProvider/StatusServiceBridgeProvider';
import { useGetConversations } from '@web/conversations/hooks/useGetConversations';

export const useStatusServiceUpdater = () => {
  const { setUnreadMessages } = useStatusServiceBridge();
  const { isLoading, data } = useGetConversations();

  useEffect(() => {
    if (isLoading) return;

    const counter = data
      // muted conversation counters do not add to global unread counters
      .filter((conversation) => !conversation.isSilenced)
      .reduce((acc, conversation) => acc + conversation.unreadMessagesCount, 0);

    setUnreadMessages(counter);
  }, [data, isLoading, setUnreadMessages]);
};
